export default __webpack_public_path__ + "static/media/demoImage.1b494ea9.svg";